import * as React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Multi-line twin of the DLZ `Input` (Figma „Input“ field: radius 18, 1 px border/subtle, 16 px
 * padding, hover / focus 2 px / error 2 px brand). The design has no separate textarea component.
 */
export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, rows = 4, ...props }, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    className={cn(
      'dlz-body-m block w-full resize-none rounded-[18px] border border-[#E2E4E7] bg-white px-4 py-3 text-[#0F1012] outline-none transition-[border-color,box-shadow] placeholder:text-[#6B7079]',
      'hover:border-[#9096A0] focus:border-[#0F1012] focus:shadow-[inset_0_0_0_1px_#0F1012]',
      'aria-[invalid=true]:border-[#D7191F] aria-[invalid=true]:shadow-[inset_0_0_0_1px_#D7191F]',
      'disabled:cursor-not-allowed disabled:border-[#E2E4E7] disabled:bg-[#ECEDEF] disabled:text-[#9096A0]',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
